import React from "react"
import { useParams } from "react-router-dom"
import EditServiceForm from "../../shared-components/adminSharedComp/EditServiceForm/EditServiceForm"

const EditServiceAdmin = () => {
  const { id, listino } = useParams()

  return (
    <div style={{ padding: 20, width: "100%" }}>
      <EditServiceForm id={id} listino={listino}/>
    </div>
  )
}

export default EditServiceAdmin
